export function stripHtml(html: string): string {
  if (!html) return '';

  // Create a temporary div element
  const tmp = document.createElement('div');
  tmp.innerHTML = html;

  // Get text content and clean up common HTML entities
  let textContent = tmp.textContent || tmp.innerText || '';

  // Clean up common HTML entities
  textContent = textContent
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, '"')
    .trim();

  return textContent;
}
